import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Thunk to fetch all news
export const fetchNews = createAsyncThunk(
    'news/fetchNews',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get('api/v1/get_all_news');
            return response.data.news || [];
        } catch (err) {
            console.error('Error fetching news:', err);
            return rejectWithValue(err.response?.data || 'Unknown error');
        }
    }
);

const newsSlice = createSlice({
    name: 'news',
    initialState: {
        allNews: [],
        loading: false,
        error: null,
    },
    reducers: {
        setAllNews(state, action) {
            state.allNews = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchNews.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchNews.fulfilled, (state, action) => {
                state.loading = false;
                state.allNews = action.payload;
            })
            .addCase(fetchNews.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { setAllNews } = newsSlice.actions;
export default newsSlice.reducer;
